export const ViewerWidths = {
  smartDocMaxWidth: 630,
  pdfDocMaxWidth: 816,
};
